import React from 'react';
import './CopyRow.css';

interface CopyRowProps {
  /** The value to copy; also what's displayed unless `display` is given */
  value: string;
  /** Rendered in place of the raw value (e.g. a truncated link) */
  display?: React.ReactNode;
  /** Style the value as a resume code (condensed, oxblood) or a link */
  variant: 'code' | 'link';
  copied: boolean;
  onCopy: () => void;
  testId?: string;
}

const CopyRow: React.FC<CopyRowProps> = ({ value, display, variant, copied, onCopy, testId }) => (
  <div className="copy-row">
    {variant === 'code' ? (
      <code className="copy-row-code" data-testid={testId}>
        {display ?? value}
      </code>
    ) : (
      <span className="copy-row-link" data-testid={testId}>
        {display ?? value}
      </span>
    )}
    <button type="button" className="copy-row-button" onClick={onCopy}>
      {copied ? '✓ Copied' : 'Copy'}
    </button>
  </div>
);

export default CopyRow;
